import { render, staticRenderFns } from "./DDingDepartment.vue?vue&type=template&id=5b5dfdec"
import script from "./DDingDepartment.vue?vue&type=script&lang=js"
export * from "./DDingDepartment.vue?vue&type=script&lang=js"
import style0 from "./DDingDepartment.vue?vue&type=style&index=0&id=5b5dfdec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports